import { AddressMap } from '../types'
import { ChainId } from '../enums'

export const USDC_ADDRESS: AddressMap = {
  [ChainId.AVALANCHE]: '0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664',
  [ChainId.AVALANCHE_TESTNET]: '0x5425890298aed601595a70AB815c96711a31Bc65'
}

export const FACTORY_ADDRESS: AddressMap = {
  [ChainId.AVALANCHE_TESTNET]: '0x6f6C1C188631D1951DcE7A9B83c65747244bF43A',
  [ChainId.AVALANCHE]: '0x32B304298d5fA82407AA552b864e9a62e3D19528'
}

export const ROUTER_ADDRESS: AddressMap = {
  [ChainId.AVALANCHE_TESTNET]: '0xEdB76bF8bdBd864ff31c66803712286dc3f0b4F7',
  [ChainId.AVALANCHE]: '0x7ddf3eCcd19f3a6A1F4e8634BfE0a32978CF038A'
}

export const ARRAY_ADDRESS: AddressMap = {
  [ChainId.AVALANCHE]: '0xEAf1A8F1BB3929a6f7365E5c38418b9032d7b2B1'
}

export const WETH9_ADDRESS: AddressMap = {
  [ChainId.AVALANCHE]: '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7',
  [ChainId.AVALANCHE_TESTNET]: '0xd00ae08403B9bbb9124bB305C09058E32C39A48c'
}

export const WNATIVE_ADDRESS: AddressMap = {
  [ChainId.AVALANCHE]: WETH9_ADDRESS[ChainId.AVALANCHE],
  [ChainId.AVALANCHE_TESTNET]: WETH9_ADDRESS[ChainId.AVALANCHE_TESTNET]
}

export const MASTERCHEF_ADDRESS: AddressMap = {
  [ChainId.AVALANCHE_TESTNET]: '0xd11e75079Ef9AE80D4C18739cF7070ED9678507d',
  [ChainId.AVALANCHE]: '0xEC8413897e056a7ee79Ab5bDacc116c27b8fF4ec'
}

export const MASTERCHEF_V2_ADDRESS: AddressMap = {}

export const STATIC_FARM_ADDRESS: AddressMap = {}

export const ENS_REGISTRAR_ADDRESS: AddressMap = {
  [ChainId.ROPSTEN]: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e'
}

export const MULTICALL2_ADDRESS: AddressMap = {
  [ChainId.AVALANCHE]: '0xdDCbf776dF3dE60163066A5ddDF2277cB445E0F3',
  [ChainId.AVALANCHE_TESTNET]: '0xA6577666FE76BA7561d2B5edd72152125d8C2891'
}

// not being used in Array
export const STOP_LIMIT_ORDER_ADDRESS: AddressMap = {
  [ChainId.KOVAN]: '0xce9365dB1C99897f04B3923C03ba9a5f80E8DB87',
  [ChainId.MATIC]: '0x1aDb3Bd86bb01797667eC382a0BC6A9854b4005f'
}
export const BENTOBOX_ADDRESS: AddressMap = {
  [ChainId.MAINNET]: '0xF5BCE5077908a1b7370B9ae04AdC565EBd643966',
  [ChainId.ROPSTEN]: '0x6BdD85290001C8Aef74f35A7606065FA15aD5ACF',
  [ChainId.RINKEBY]: '0xF5BCE5077908a1b7370B9ae04AdC565EBd643966',
  [ChainId.GÖRLI]: '0xF5BCE5077908a1b7370B9ae04AdC565EBd643966',
  [ChainId.KOVAN]: '0x9A0D9920D92c178a58D99B455898Df2df22A2eE4',
  [ChainId.FANTOM]: '0xF5BCE5077908a1b7370B9ae04AdC565EBd643966',
  [ChainId.MATIC]: '0x0319000133d3AdA02600f0875d2cf03D442C3367',
  [ChainId.MATIC_TESTNET]: '0xF5BCE5077908a1b7370B9ae04AdC565EBd643966',
  [ChainId.XDAI]: '0xE2d7F5dd869Fc7c126D21b13a9080e75a4bDb324',
  [ChainId.BSC]: '0xF5BCE5077908a1b7370B9ae04AdC565EBd643966',
  [ChainId.BSC_TESTNET]: '0xF5BCE5077908a1b7370B9ae04AdC565EBd643966',
  [ChainId.ARBITRUM]: '0x74c764D41B77DBbb4fe771daB1939B00b146894A',
  [ChainId.AVALANCHE]: '0x0711B6026068f736bae6B213031fCE978D48E026',
  [ChainId.HECO]: '0xF5BCE5077908a1b7370B9ae04AdC565EBd643966'
}
